/**
 * A helper to be used in client-side search filtering for schedules. fiq-2152
 *
 * Filters on schedule name(label) and code, including results that contain leading Cs for custom
 * schedules.
 *
 * Scoped to regime schedule search filtering currently - schedule filtering is duplicated across
 * multiple routes, filter-view is a next candidate for this helper.
 *
 * @param {Object} item - an individual schedule to compare against the search
 * @param {string} searchTerm - the text field input used for comparison
 * @returns {boolean}
 */
export function scheduleSearchFilter(item, searchTerm) {
    const l = item?.label?.toLowerCase?.()
    const c = item?.code?.toLowerCase?.()
    const search = searchTerm?.toLowerCase?.()

    const CUSTOM_SCHEDULE = "2"
    return (
        l?.includes?.(search) ||
        c?.startsWith?.(search) ||
        (`${item?.ScheduleType}` === CUSTOM_SCHEDULE ? customScheduleCodeMatch(c, search) : false)
    )
}

function customScheduleCodeMatch(c, search) {
    const splitCode = c?.split?.("-") ?? []

    let uniqueCode
    if (splitCode.length > 2) uniqueCode = splitCode.slice(2).join("-") // covers cases C61-05-<0133>, C61-05-<0001-29>
    if (splitCode.length > 4) uniqueCode = splitCode.slice(4).join("-") // covers cases C73-03-0001-31-<1234-0001>

    return c?.startsWith?.(`c${search}`) || uniqueCode?.startsWith?.(search)
}
